export default __webpack_public_path__ + "static/media/CapaGroupChatBot.c11c01b4.svg";